module.exports = __webpack_public_path__ + "img/microsoft-excel.5a66db9c.svg";